import "./Header.scss";
import NavBar from "./NavBar";

const Header = () => {
  return (
    <>
      <div className="header__container">
        <div>
          <NavBar />
        </div>
      </div>
    </>
  );
};

export default Header;
